import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { TableCustom } from "../Structure/navbar/blueprintTableincludes";
import { mefMontantStr } from "../../utils/mef";
import i18next from 'i18next';



class TableTickets extends React.Component {
  constructor() {
    super();
    this.state = {
    }
  }

  formatValue=(type, value)=>{
    if(type === 'external_value')
      return mefMontantStr(value);
    if(type === 'value')
      return mefMontantStr(value * 100);
    if(type === 'percent')
      return value + "%";
    if(type === 'time' || type === 'time_start')
      return value + " min";
    else return value;
  }
 getType=(type)=>{
    let label =`bonitick_${type}`;
    if(type === 'time')
      label =`bonitick_time_end`;
    else if(type === 'time_start')
      label =`bonitick_time_start`;
    return i18next.t(label);
  }


  render() {
    return (
      <div>
        <div style={{ height: '70vh', overflow: 'auto' }} >
          <div>
            <TableCustom
              paging={true}
              url={"/bonification/ticketsTable"}
              orderBy="date"
              columns={[
                {
                  title: <Trans>ticket</Trans>,
                  field: "ticketId",
                  sortable: true,
                  render: raw => raw.idTicket
                },
                {
                  title: <Trans>entry date</Trans>,
                  field: "entryDate",
                  sortable: true,
                  render: raw => { return new Date(raw.entryDate).toLocaleString(i18next.language) }
                },
                {
                  title: <Trans>bonification date</Trans>,
                  field: "date",
                  sortable: true,
                  render: raw => { return new Date(raw.discountDate).toLocaleString(i18next.language) }
                },
                {
                  title: <Trans>site</Trans>,
                  field: "site",
                  sortable: true,
                  render: raw => raw.site 
                },
                {
                  title: <Trans>park</Trans>,
                  field: "park",
                  sortable: true,
                  render: raw => raw.park
                },
                {
                  title: <Trans>store</Trans>,
                  field: "store",
                  sortable: true,
                  render: raw => raw.store
                },
                {
                  title: <Trans>bonification</Trans>,
                  field: "label",
                  sortable: false,
                  render: raw => raw.label
                },
                {
                  title: <Trans>type</Trans>,
                  field: "type",
                  sortable: false,
                  render: raw => this.getType(raw.type)
                },
                {
                  title: <Trans>value</Trans>,
                  field: "value",
                  sortable: false,
                  render: raw => this.formatValue(raw.type, raw.value)
                },
                {
                  title: <Trans>username</Trans>,
                  field: "userName",
                  sortable: false,
                  render: raw => raw.userName
                },
                {
                  title: <Trans>vendorname</Trans>,
                  field: "vendorName",
                  sortable: false,
                  render: raw => raw.vendorName
                }
              ]}
            />
          </div>
        </div>
      </div >
    )
  }
}

export default withTranslation()(TableTickets);